import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useDispatch } from 'react-redux';

import { ListItem, ListItemText } from '@material-ui/core';
import { ListItemProps } from '@material-ui/core/ListItem';

import axiosClient from '@lib/utils/axiosClient';

import { showMessage } from 'actions';

const messages = defineMessages({
  text: {
    id: 'components.v2.ListItemPatientsDownloadDoNotContact.text',
    defaultMessage: "Download 'Do Not Contact' patients",
  },
  messageSuccess: {
    id: 'components.v2.ListItemPatientsDownloadDoNotContact.messageSuccess',
    defaultMessage: `We'll send you an email once your download is ready`,
  },
});

export interface ListItemPatientsDownloadDoNotContactProps extends Omit<ListItemProps, 'classes'> {}

const ListItemPatientsDownloadDoNotContact: React.FC<ListItemPatientsDownloadDoNotContactProps> = ({
  onClick = () => {},
  ...rest
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return (
    <ListItem
      button
      onClick={(event) => {
        axiosClient.get('/patients/reports/do-not-contact-patients/xls').then(() => {
          dispatch(showMessage(formatMessage(messages.messageSuccess), 'info'));
        });
        onClick(event);
      }}
      {...rest}
    >
      <ListItemText primary={formatMessage(messages.text)} />
    </ListItem>
  );
};

export default ListItemPatientsDownloadDoNotContact;
